export default __webpack_public_path__ + "static/media/diamond_icon.f28e0de6.svg";